<template>
  <template v-if="form">
    <form class="fr-form ">
      <slot></slot>
    </form>
  </template>
  <template v-else>
    <div class="fr-form ">
      <slot></slot>
    </div>
  </template>
</template>
<script setup>
const props = defineProps({
  form: {
    type: Boolean,
    default: false
  }
})
</script>
